import { useState } from "react";
import { colors, fonts } from "../../styles/theme";
import { updateContact } from "../../services/api";
import { FREQ_OPTIONS } from "./constants";

export default function EmailFrequencySelector({ contact }) {
  const current = contact.emailFrequency || "all";
  const [saving, setSaving] = useState(false);

  const handleChange = async (e) => {
    const value = e.target.value;
    setSaving(true);
    try {
      await updateContact(contact.id, { email: contact.email, emailFrequency: value });
      contact.emailFrequency = value;
    } catch (err) {
      alert(`Failed to update: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <div
        style={{
          fontSize: 11,
          color: colors.textSecondary,
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          marginBottom: 8,
        }}
      >
        Email Frequency
      </div>
      <select
        value={current}
        onChange={handleChange}
        disabled={saving}
        style={{
          width: "100%",
          padding: "8px 12px",
          fontSize: 13,
          fontFamily: fonts.body,
          background: colors.bg,
          color: colors.text,
          border: `1px solid ${colors.border}`,
          borderRadius: 6,
          cursor: saving ? "wait" : "pointer",
          opacity: saving ? 0.6 : 1,
        }}
      >
        {FREQ_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
